import React from 'react';
import { Container } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { ClassNameMap } from '@mui/styles';
import { ReactComponent as ZTLoginPageLogo } from './images/LoginPage_ZT_Logo.svg';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '76.7vh',
    paddingBottom: theme.spacing(6)
  }
}));

type SplashLogoProps = {
  classes?: ClassNameMap;
};

export const SplashLogo: React.FC<SplashLogoProps> = ({
  classes: overrideClasses
}: SplashLogoProps) => {
  const classes = useStyles({
    classes: overrideClasses
  });

  return (
    <Container className={classes.wrapper} data-testid="splash-logo-skeleton">
      <ZTLoginPageLogo />
    </Container>
  );
};
